<template>
    <div v-cloak>
        <v-card id="collegecard" elevation="4" class="mb-8">
            <v-toolbar color="red darken-2" dark flat dense>
                <v-toolbar-title>Your Student Card</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-scroll-to="'#top'" dark text>
                    <v-icon left>fas fa-chevron-up</v-icon>
                    Top
                </v-btn>
                <span v-if="HasCollegeCard" v-scroll-to="'#kickers'" class="fa-stack fa-md icon-success">
                    <i class="fa fa-circle fa-stack-2x"></i>
                    <i class="fa fa-check fa-stack-1x"></i>
                </span>
                <span v-else v-scroll-to="'#kickers'" class="fa-stack fa-md icon-info">
                    <i class="fa fa-circle fa-stack-2x"></i>
                    <i class="fa fa-info fa-stack-1x"></i>
                </span>
            </v-toolbar>
            <v-card-text>
                <p class="text-h6 mb-0">Want student discounts?  You need a Student Card for that.</p>
            </v-card-text>
            <v-card-text v-if="!WillAutoOrderCard && HasCollegeCardOptedIn" class="pt-0">
                <v-alert type="success" outlined dense text>You have successfully opted in to receive a Student Card</v-alert>
            </v-card-text>
            <v-card-text v-else-if="!WillAutoOrderCard && !HasCollegeCardOptedIn" class="pt-0">
                <v-alert type="info" outlined dense text>If you would like a Student Card, click to opt in below</v-alert>
                <p>Only courses that are longer than {{ MinimumEnrolmentEligible }} days are eligible for a Student Card.</p>
                <p>Please ensure you have uploaded a photo.</p>
                <p>If you choose not to opt in, a Student Card will not be ordered for you.</p>
                <p>If you change your mind, please contact your <a href="#" @click="GoToHelpPoint">Campus Help Point</a> to get one ordered.</p>
            </v-card-text>
            <v-card-text v-else-if="(WillAutoOrderCard || HasCollegeCardOptedIn) && !HasCollegeCard" class="pt-0">
                <p v-if="HasRegisteredOrCurrentEnrolments && PhotoVerified">Your photo has been approved and your Student Card will be ordered automatically in due course.</p>
                <p v-if="HasRegisteredOrCurrentEnrolments && !PhotoVerified">Please upload a photo and your Student Card will be ordered automatically once your photo has been verified.</p>
                <p v-if="!HasRegisteredOrCurrentEnrolments">Please complete your online registration in order to be eligible for a Student Card.</p>
            </v-card-text>
            <v-card-text v-else-if="(WillAutoOrderCard || HasCollegeCardOptedIn) && HasCollegeCard" class="pt-0">
                <p v-if="collegeCard.Status == 'Active'">Your Student Card has been ordered and is active.  It can take 10-15 working days to arrive.  It will be posted to your term-time address.</p>
                <p v-if="collegeCard.Status == 'Active'">If it has not arrived within this timescale, please contact your <a href="#" @click="GoToHelpPoint">Campus Help Point</a>.</p>

                <v-alert v-if="collegeCard.Status == 'Cannot Be Ordered'" type="error" outlined dense text>Your Student Card Cannot Be Ordered: {{ collegeCard.Message }}</v-alert>
                <p v-if="collegeCard.Status == 'Cannot Be Ordered' && collegeCard.Message == 'No Picture'">Your Student Card cannot be ordered as we do not have a photo for you. Please follow the photo guidance to upload a suitable photo.</p>
                <p v-if="collegeCard.Status == 'Cannot Be Ordered' && collegeCard.Message != 'No Picture'">Your Student Card cannot be ordered as the photo you uploaded was rejected.  Please follow the photo guidance to upload a suitable photo.</p>
            </v-card-text>
            <v-card-actions v-if="!WillAutoOrderCard && !HasCollegeCardOptedIn">
                <v-btn @click="ConfirmOptIn" color="success" dark small style="color:white !important">
                    <v-icon left small>fas fa-check</v-icon>
                    Opt In for a Student Card
                </v-btn>
            </v-card-actions>
        </v-card>

        <confirm-dialog instance="confirm-opt-in"
                        title="Confirm Student Card Opt-In"
                        question="Are you sure you want to opt-in to receive a Student Card?"
                        no-label="No, not at this time"
                        yes-label="Yes, opt me in"
                        button-color="success"></confirm-dialog>
    </div>
</template>

<script>
    import { eventBus } from '@/main'

    import ctrlOpenMixin from '@/views/components/mixins/base/ctrlOpen.js'
    import enrolmentsMixin from '@/views/components/mixins/enterpriseDataApi/enrolments.js'
    import photosMixin from '@/views/components/mixins/photos.js'
    import collegeCardsMixin from '@/views/components/mixins/collegeCards.js'

    import confirmDialog from '@/views/components/dialogs/ConfirmDialog'

    export default {
        props: ['collegeCardLocalSettings', 'enrolments', 'photo', 'collegeCard', 'collegeCardOptIn'],
        mixins: [
            ctrlOpenMixin,
            enrolmentsMixin,
            photosMixin,
            collegeCardsMixin,
        ],
        components: {
            'confirm-dialog': confirmDialog,
        },
        data() {
            return {
                collegeCardsLocalSettings: {},
            }
        },
        computed: {
            MinimumEnrolmentEligible() { return this.collegeCardsLocalSettings?.keyValuePairs?.MinimumEnrolmentEligible; },
            WillAutoOrderCard() { return this.HasFTEnrolments || this.ActiveEnrolments.indexOf(e => e.ModeOfAttendanceCode == '11') > -1; },
        },
        mounted() {
            this.LoadCollegeCardsLocalSettings();
        },
        methods: {
            GoToHelpPoint() { this.CtrlOpen(`/here-to-help`); },
            ConfirmOptIn() {
                eventBus.$off('confirm-opt-in:ok').$on('confirm-opt-in:ok', () => eventBus.$emit('college-card-opt-in:save'));
                eventBus.$emit('confirm-opt-in:show');
            },
        },
    }
</script>
